import { render, staticRenderFns } from "./SectionWithBottomImage.vue?vue&type=template&id=c502897e&"
import script from "./SectionWithBottomImage.vue?vue&type=script&lang=js&"
export * from "./SectionWithBottomImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports